import axios from '../axios'

/*
 * 项目专家
 */

// 保存
export const save = (data) => {
  return axios({
    url: '/mProjectExpert/save',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
// 删除
export const deleteProjectExpert = (data) => {
  return axios({
    url: '/mProjectExpert/delete',
    method: 'post',
    data
  })
};
// 分页查询
export const list = (data) => {
  return axios({
    url: '/mProjectExpert/list',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

export const getProjectExpertByCondition = (data) => {
  return axios({
    url: '/mProjectExpert/getProjectExpertByCondition',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
//随机抽取
export const projectExpertExtract = (data) => {
  return axios({
    url: '/mProjectExpert/projectExpertExtract',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/http/moudules/projectExpert.js